import { useEffect, Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import Text from "../../../components/ui/Text";
import Touchable from "../../../components/ui/Touchable";
import useEmailLogin from "../../../services/webLogin/useEmailLogin";
import useResendSmsCode from "../../../services/webLogin/useResendSmsCode";
import { MarketType } from "../../../types";
import { CountDownTime, CountDownTimeJp } from "../constants";

export default function CountDownAndResend({
  market,
  showSmsDrawer,
  account,
  timeLeft,
  setTimeLeft,
}: {
  market?: MarketType;
  showSmsDrawer: boolean;
  account: string;
  timeLeft: number;
  setTimeLeft: Dispatch<SetStateAction<number>>;
}) {
  const { t } = useTranslation();

  useEffect(() => {
    if (timeLeft === 0 || !showSmsDrawer) return;

    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft, showSmsDrawer, setTimeLeft]);

  const mutationForResendSms = useResendSmsCode();
  const mutationForResendEmail = useEmailLogin();
  const mutationForResend =
    market === "JP" ? mutationForResendEmail : mutationForResendSms;

  const handleResend = () => {
    if (mutationForResend.isLoading) return;

    mutationForResend.mutate(account, {
      onSuccess: () => {
        setTimeLeft(market === "JP" ? CountDownTimeJp : CountDownTime);
      },
    });
  };

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const countDownLabel =
    market === "JP"
      ? minutes > 0
        ? `${minutes}分${String(seconds).padStart(2, "0")}秒`
        : `${seconds}秒`
      : `${timeLeft} ${t("seconds")}`;

  return (
    <div className="flex h-11 w-fit flex-1 items-center justify-center">
      {timeLeft > 0 ? (
        <Text className="text-grey4">{countDownLabel}</Text>
      ) : (
        <Touchable
          className="flex h-9 w-fit items-center rounded-full border border-solid border-black8 px-4"
          onClick={handleResend}
        >
          <Text className="text-nowrap">{t("resend")}</Text>
        </Touchable>
      )}
    </div>
  );
}
